import React from "react";

function useOpen(props?: { initialState: boolean }) {
  const [isOpen, setUpen] = React.useState(props?.initialState ?? false);

  const open = () => setUpen(true);
  const dismiss = () => setUpen(false);
  const toggle = () => setUpen(!isOpen);
  const set = (value: boolean) => setUpen(value);

  return {
    isOpen: isOpen,
    actions: {
      open,
      dismiss,
      toggle,
      set,
    },
  };
}

export default useOpen;
